import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import EventList from './eventsList';
import FilterButtonDrawer from './filterButtonDrawer';
import EventContextProvider from './context/EventContextProvider';
import PrepareContextProvider from './context/PrepareContextProvider';
import FilterBadges from './filters/filterBadges';
import { Container, Image, Stack, Box, Spinner } from '@chakra-ui/core';
import ScrollToTop from '../common/scrollToTop';
import imgLogo from '../images/logo-wide-dark.svg';
import ProgrammaFile from './component/programmaFile';
import ChatWrapper from '../chat/ChatWrapper';
import { useProgrammaMetaQueryGQL } from './queries/getProgrammaMeta';
import { useHistory, useParams } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

const Event = () => {
    let edition = useParams();
    const [value] = Object.values(edition);
    const { loading, data, error } = useProgrammaMetaQueryGQL({ editionName: value });
    if (loading)
        return (
            <Box textAlign='center'>
                <Spinner color='brand.500' />
            </Box>
        );
    if (error) return <p>ERROR</p>;
    if (!data) return <p>Not found</p>;

    const programma = data.getProgramma;

    if(programma) {
        return (
            <PrepareContextProvider>
                <EventContextProvider>
                    <ScrollToTop />
                    <Helmet title={programma.metaTitle}>
                        <meta name='description' content={programma.metaDescription} />
                        <meta name='image' content={programma.metaPhotoUrl} />
                        <meta itemprop='name' content='Klive' />
                        <meta itemprop='description' content={programma.metaDescription} />
                        <meta itemprop='image' content={programma.metaPhoto} />

                        <meta name='twitter:card' content='summary' />
                        <meta name='twitter:title' content={programma.metaTitle} />
                        <meta name='twitter:description' content={programma.metaDescription} />
                        <meta name='twitter:site' content='' />
                        <meta name='twitter:image' content={programma.metaPhotoUrl} />

                        <meta name='og:title' content={programma.metaTitle} />
                        <meta name='og:description' content={programma.metaDescription} />
                        <meta name='og:image' content={programma.metaPhotoUrl} />
                        <meta name='og:url' content='https://fss.klive.com' />
                        <meta name='og:site_name' content='Klive' />
                        <meta name='og:locale' content='en_US' />
                        <meta name='og:type' content='website' />
                    </Helmet>
                    <Container maxW='1312px' my={[4, 4, 8, 12]} centerContent>
                        {programma.metaPhotoUrl && (
                            <>{<Image src={programma.metaPhotoUrl} alt='Forum Sistema Salute' />}</>
                        )}
                    </Container>
                    <Container maxW='1312px'>
                        <Stack direction={['column', 'column', 'row']} alignItems='end' mb={[4, 4, 8]}>
                            <ProgrammaFile yearEdition={value} />
                            <FilterButtonDrawer />
                        </Stack>
                        <FilterBadges />
                    </Container>
                    <EventList />
                </EventContextProvider>
            </PrepareContextProvider>
        );
    }

    return <Redirect to={`/programma/${new Date().getFullYear() - 1}`} />
};

Event.propTypes = {};

export default Event;
